// Return Cloudinary URL for where to store attachments for the Resource Library

function getResourceAttachmentUploadPath(communityId) {
  return `/community/${communityId}/schools/resource/attachments`
}

export default getResourceAttachmentUploadPath
